var App = App || {};

App.SubsidiaryCollectionFrontMatter = (function ($) {
    'use strict';

    return {
        init: _init
    };

    function _init() {        
        if (!_frontMatterIsOnPage()) {
            return;
        }

        _initFrontMatterToggle();
    }

    function _frontMatterIsOnPage() {        
        return $('.front-matter-section').length > 0 || $('.js-front-matter-toggle').length > 0;
    }

    function _initFrontMatterToggle() {
        $('.js-front-matter-toggle').each(function() {
            var $button = $(this);
            $button.attr('aria-controls', 'front-matter-content');
        });

        $('.master-main, .pg_SubsidiaryCollection').on('click', '.js-front-matter-toggle', function(e) {
            e.preventDefault();

            var $currentTarget = $(e.currentTarget);
            var $expandable = $currentTarget.closest('.js-front-matter-expandable');
            var $content = $expandable.find('.js-front-matter-content');
            var $toggleText = $currentTarget.find('.js-front-matter-toggle-text');
            var $icon = $currentTarget.find('.js-front-matter-icon');
            var toggleIconClass = $icon.attr('data-icon-class') || 'icon-general-arrow-filled';
            var downArrow = toggleIconClass + '-down';
            var upArrow = toggleIconClass + '-up';

            $content.toggleClass('hide');
            var isVisible = !$content.hasClass('hide');

            $currentTarget.attr('aria-expanded', isVisible ? 'true' : 'false');

            $toggleText.toggleClass('front-matter-toggle-text--active', isVisible);

            $icon.toggleClass(downArrow);
            $icon.toggleClass(upArrow);
        });
    }
})(jQuery);